export enum LogoDisplayOptions {
  FULL = 'full',
  SHORT = 'short',
  HIDDEN = 'hidden',
}
